import React from "react";
import logger from "logger";

import AccountDetailsSection from "TaskHistory/Tasklet/SubTasklets/AccountDetailsSection.js";
import StatusSection from "TaskHistory/Tasklet/SubTasklets/StatusSection.js";
import ErrorLogsSection from "TaskHistory/Tasklet/SubTasklets/ErrorLogsSection.js";
import ActionsSection from "TaskHistory/Tasklet/SubTasklets/ActionsSection.js";
import TaskletCard from "./TaskletCard";
import { StringValue } from "./StringValue";
import CardContent from "@material-ui/core/CardContent";

export default function(props) {
  const { task } = props;

  return (
    <TaskletCard title="Upgrading Mount To Max">
      <CardContent>
        <AccountDetailsSection task={task} />
        <StringValue label={"Mount"} value={task.taskstatusdetail.mountname} />
        <StatusSection task={task} />
        <StringValue
          label={"Mount Currently At Level:"}
          value={`Lv. ${task.taskstatusdetail.currentlevel}`}
        />
        <ErrorLogsSection task={task} />
      </CardContent>
      <ActionsSection task={task} />
    </TaskletCard>
  );
}
